import React from 'react'
import PropTypes from 'prop-types'
import UserAvatarList from '../../UserAvatarList'
import Tag from '../../../Atoms/Tag'
import TableCurrentStep from '../../TableCurrentStep'
import TableRow from '../../../Wrappers/TableRow'
import {findProcessStep} from '../../../../helpers/payroll'
import {history} from '../../../../helpers/history'
import {useRouteMatch} from 'react-router-dom'

const PayrollProcessRow = props => {
  const {process} = props
  let {path} = useRouteMatch()

  const handleClickProcessRow = process => history.push(`${path}/${process.id}`)

  return (
    <TableRow>
      <p className="s-mb-0">{process.id}</p>
      <p className="s-mb-0">{process.name}</p>
      <p className="s-mb-0">{process.type}</p>
      <UserAvatarList employees={process.employees} />
      <Tag text={process.status} color="green" />
      <TableCurrentStep
        isFinished={process.isFinished}
        steps={process.steps}
        currentStep={findProcessStep(process.current).name}
        onClick={() => {
          handleClickProcessRow(process)
        }}
      />
    </TableRow>
  )
}

PayrollProcessRow.propTypes = {
  process: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    employees: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    steps: PropTypes.array.isRequired,
    current: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    process: PropTypes.bool.isRequired,
  }).isRequired,
}

export default PayrollProcessRow
